import { useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";

let scriptPromise;

function loadTurnstile() {
  if (window.turnstile) return Promise.resolve();
  if (scriptPromise) return scriptPromise;
  scriptPromise = new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
    script.async = true;
    script.defer = true;
    script.onload = resolve;
    script.onerror = reject;
    document.head.appendChild(script);
  });
  return scriptPromise;
}

export default function TurnstileWidget({ onToken }) {
  const targetRef = useRef(null);
  const widgetRef = useRef(null);
  const callbackRef = useRef(onToken);
  const [siteKey, setSiteKey] = useState("");

  useEffect(() => {
    callbackRef.current = onToken;
  }, [onToken]);

  useEffect(() => {
    api.get("/public/config")
      .then(({ data }) => setSiteKey(data?.turnstile_site_key || ""))
      .catch(() => setSiteKey(""));
  }, []);

  useEffect(() => {
    if (!siteKey || !targetRef.current) return undefined;
    let cancelled = false;
    loadTurnstile().then(() => {
      if (cancelled || !targetRef.current || !window.turnstile) return;
      widgetRef.current = window.turnstile.render(targetRef.current, {
        sitekey: siteKey,
        theme: "dark",
        callback: (token) => callbackRef.current(token),
        "expired-callback": () => callbackRef.current(""),
        "error-callback": () => callbackRef.current(""),
      });
    });
    return () => {
      cancelled = true;
      if (widgetRef.current !== null && window.turnstile) {
        window.turnstile.remove(widgetRef.current);
        widgetRef.current = null;
      }
    };
  }, [siteKey]);

  if (!siteKey) return null;
  return <div className="turnstile-wrap" ref={targetRef} aria-label="Spam-Schutz" />;
}
